import { useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import {motion,useInView,AnimatePresence } from "framer-motion";
import uk1 from "../assets/countries/uk/uk1.webp";
import uk2 from "../assets/countries/uk/uk2.webp";
import uk3 from "../assets/countries/uk/Uk mini 1.webp";
import uk4 from "../assets/countries/uk/uk mini 2.webp";
import uk5 from "../assets/countries/uk/uk mini 3.webp";  
import can1 from "../assets/countries/canada/canada 1.webp";
import can2 from "../assets/countries/canada/Canada 2.webp";
import can3 from "../assets/countries/canada/canada mini 1.webp";
import can4 from "../assets/countries/canada/canada mini 2.webp";
import can5 from "../assets/countries/canada/canada mini 3.webp";
import usa1 from "../assets/countries/usa/usa 1.webp";
import usa2 from "../assets/countries/usa/usa 2.webp";
import usa3 from "../assets/countries/usa/usa mini 1.webp";
import usa4 from "../assets/countries/usa/usa mini 2.webp";
import usa5 from "../assets/countries/usa/usa mini 3.webp"; 
import germany1 from "../assets/countries/germany/germany-1.webp";
import germany2 from "../assets/countries/germany/germany-2.webp";
import  germany3 from "../assets/countries/germany/germany mini 1.webp";
import  germany4 from "../assets/countries/germany/germany mini 2.webp";
import  germany5 from "../assets/countries/germany/germany mini 3.webp";  
import france1 from "../assets/countries/france/france 1.webp";
import france2 from "../assets/countries/france/france 2.webp";
import france3 from "../assets/countries/france/France MIni one.webp";
import france4 from "../assets/countries/france/France mini 2.webp";
import france5 from "../assets/countries/france/France mini 3.webp";
import ireland1 from "../assets/countries/ireland/ireland 1.webp";
import ireland2 from "../assets/countries/ireland/ireland 2.webp";
import ireland3 from "../assets/countries/ireland/ireland mini 1.webp";
import ireland4 from "../assets/countries/ireland/ireland mini 2.webp";
import ireland5 from "../assets/countries/ireland/ireland mini 3.webp";
import newzealand1 from "../assets/countries/nz/New Zealand 1.webp";
import newzealand2 from "../assets/countries/nz/New Zealand 2.webp";
import newzealand3 from "../assets/countries/nz/Newzealand mini 1.webp";
import newzealand4 from "../assets/countries/nz/Newzealand mini 2.webp";
import newzealand5 from "../assets/countries/nz/nz3.webp";
import australia1 from "../assets/countries/aus/Australia.webp";
import australia2 from "../assets/countries/aus/Australia 2.webp";
import australia3 from "../assets/countries/aus/australia mini 1.webp";
import australia4 from "../assets/countries/aus/australia mini 2.webp";
import australia5 from "../assets/countries/aus/australia mini 3.webp";
const destinationData = {
  uk: {
    name: "United Kingdom",
    hero: uk1,
    sideImage: uk2,
    why: `The United Kingdom is one of the world’s most prestigious study destinations, known for its high-quality education system and globally recognized universities. The UK hosts some of the oldest and most respected institutions, including Oxford, Cambridge, Imperial College London, and University College London, attracting students from across the globe.
    `,
    flag: "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
     whyImages: {
    top: uk3,        // Top Universities image
    campus: uk4,     // Campus Life image
    life: uk5
  },
    whyTabs: {
    top: `The UK hosts globally ranked universities including Oxford, Cambridge, Imperial College London, and UCL. These institutions are known for academic excellence, innovation, and world-class research.`,

    campus: `UK campuses offer vibrant student communities, modern facilities, global networking opportunities, strong industry partnerships, and a supportive international student environment.`,

    life: `Life in the UK offers cultural diversity, part-time work opportunities, strong public transport, safety, global career exposure, and an excellent quality of living.`
  },
    universities: {
      Universities: [
         { name: "University of Birmingham", link: "https://www.birmingham.ac.uk" },
  { name: "University of Bristol", link: "https://www.bristol.ac.uk" },
  { name: "Durham University", link: "https://www.durham.ac.uk" },
  { name: "University of Edinburgh", link: "https://www.ed.ac.uk" },
  { name: "Brunel University London", link: "https://www.brunel.ac.uk" }
      ],
    
    },
  },

  canada: {
  name: "Canada",
  hero: can1,
  sideImage: can2,
  flag: "https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Canada.svg",

  why: `
Canada offers affordable education, multicultural society, and excellent post-study work opportunities.
  `,
     whyImages: {
    top: can3,        // Top Universities image
    campus: can4,     // Campus Life image
    life: can5
  },
  whyTabs: {
    top: "Canada has globally ranked universities like Toronto and McGill known for strong research and innovation.",
    campus: "Canadian campuses offer safe, multicultural student communities and modern facilities.",
    life: "Life in Canada offers high living standards, PR pathways, part-time jobs, and safety."
  },

  universities: {
    Universities: [
      {
    name: "University of Windsor",
    link: "https://www.uwindsor.ca"
  },
  {
    name: "Lakehead University",
    link: "https://www.lakeheadu.ca"
  },
  {
    name: "Kwantlen Polytechnic University",
    link: "https://www.kpu.ca"
  },
  {
    name: "Royal Roads University",
    link: "https://www.royalroads.ca"
  },
  {
    name: "University of Manitoba",
    link: "https://umanitoba.ca"
  },
  {
    name: "European School of Esthetics",
    link: "https://europeanschoolofesthetics.com"
  }
    ],
  },
},


  usa: {
  name: "United States",
  hero: usa1,
  sideImage: usa2,
  flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",

  why: `
The USA leads in innovation, research, world-class universities, and career prospects.
  `,
     whyImages: {
    top: usa3,        // Top Universities image
    campus: usa4,     // Campus Life image
    life: usa5
  },

  whyTabs: {
    top: "The USA hosts world-leading universities like Harvard, MIT, and Stanford.",
    campus: "US campuses provide cutting-edge innovation, industry connections, and vibrant student culture.",
    life: "Life in the USA offers global exposure, career growth, strong salaries, and cultural diversity."
  },

  universities: {
    Universities: [
      { name: "University of Texas at Austin", link: "https://www.utexas.edu" },
  { name: "Duke University", link: "https://www.duke.edu" },
  { name: "Washington University in St. Louis", link: "https://washu.edu" },
  { name: "Vanderbilt University", link: "https://www.vanderbilt.edu" },
  { name: "Johns Hopkins University", link: "https://www.jhu.edu" },
  { name: "Northwestern University", link: "https://www.northwestern.edu" },
  { name: "Rice University", link: "https://www.rice.edu" }
    ],
  },
},
australia: {
  name: "Australia",
  hero: australia1,
  sideImage: australia2,
  flag: "https://upload.wikimedia.org/wikipedia/en/b/b9/Flag_of_Australia.svg",

  why: `
Australia offers high-quality education, strong post-study work opportunities, and a great lifestyle.
  `,
   whyImages: {
    top: australia3,        // Top Universities image
    campus: australia4,     // Campus Life image
    life: australia5
  },
  whyTabs: {
    top: "Australia has top-ranked universities like Melbourne, ANU, and Sydney.",
    campus: "Australian campuses provide modern facilities, strong research culture, and vibrant student communities.",
    life: "Life in Australia offers great weather, part-time jobs, safety, and PR pathways."
  },

  universities: {
    Universities: [
      {
    name: "Australian National University",
    link: "https://www.anu.edu.au"
  },
  {
    name: "Charles Sturt University",
    link: "https://www.csu.edu.au"
  },
  {
    name: "The University of Sydney",
    link: "https://www.sydney.edu.au"
  },
  {
    name: "Southern Cross University",
    link: "https://www.scu.edu.au"
  },
  {
    name: "Flinders University",
    link: "https://www.flinders.edu.au"
  }
    ],
  
  },
},
germany: {
  name: "Germany",
  hero: germany1,
  sideImage: germany2,
  flag: "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",

  why: `
Germany offers low-cost education, strong engineering programs, and excellent job opportunities.
  `,
   whyImages: {
    top: germany3,        // Top Universities image
    campus: germany4,     // Campus Life image
    life: germany5
  },
  whyTabs: {
    top: "Germany hosts top universities like TUM, Heidelberg, and RWTH Aachen.",
    campus: "German campuses focus on innovation, research excellence, and industry partnerships.",
    life: "Life in Germany offers affordable living, part-time jobs, and strong career prospects."
  },

  universities: {
    Universities: [
      {
    name: "Lancaster University",
    link: "https://www.lancaster.ac.uk"
  },
  {
    name: "Berlin School of Business & Innovation",
    link: "https://www.berlinsbi.com"
  },
  {
    name: "Karlsruhe Institute of Technology",
    link: "https://www.kit.edu"
  }
    ],
  
  },
},
ireland: {
  name: "Ireland",
  hero: ireland1,
  sideImage: ireland2,
  flag: "https://upload.wikimedia.org/wikipedia/commons/4/45/Flag_of_Ireland.svg",

  why: `
Ireland is known for strong tech education, global companies, and post-study job opportunities.
  `,
    whyImages: {
    top: ireland3,        // Top Universities image
    campus: ireland4,     // Campus Life image
    life: ireland5
  },
  whyTabs: {
    top: "Ireland has top universities like Trinity College Dublin and UCD.",
    campus: "Irish campuses provide strong academic support, research opportunities, and innovation hubs.",
    life: "Life in Ireland offers career opportunities, cultural richness, and friendly communities."
  },

  universities: {
    Universities: [
      {
    name: "University College Cork",
    link: "https://www.ucc.ie"
  },
  {
    name: "Dublin City University",
    link: "https://www.dcu.ie"
  },
  {
    name: "University of Limerick",
    link: "https://www.ul.ie"
  },
  {
    name: "Maynooth University",
    link: "https://www.maynoothuniversity.ie"
  },
  {
    name: "Technological University Dublin",
    link: "https://www.tudublin.ie"
  }
    ],
   
  },
},
france: {
  name: "France",
  hero: france1,
  sideImage: france2,
  flag: "https://upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg",

  why: `
France offers affordable education, strong arts, business programs, and cultural richness.
  `,
   whyImages: {
    top: france3,        // Top Universities image
    campus: france4,     // Campus Life image
    life: france5
  },
  whyTabs: {
    top: "France has prestigious universities like Sorbonne and HEC Paris.",
    campus: "French campuses provide innovative learning, global exposure, and modern facilities.",
    life: "Life in France offers cultural diversity, part-time jobs, and quality lifestyle."
  },

  universities: {
    Universities: [
     {
    name: "Aix-Marseille University",
    link: "https://www.univ-amu.fr"
  },
  {
    name: "University of Strasbourg",
    link: "https://www.unistra.fr"
  },
  {
    name: "University of Bordeaux",
    link: "https://www.u-bordeaux.fr"
  },
  {
    name: "University of Lille",
    link: "https://www.univ-lille.fr"
  }
    ],
  
  },
},
newzealand: {
  name: "New Zealand",
  hero: newzealand1,
  sideImage:  newzealand2,
  flag: "https://upload.wikimedia.org/wikipedia/commons/3/3e/Flag_of_New_Zealand.svg",

  why: `
New Zealand offers high-quality education, research excellence, and a safe student environment.
  `,
   whyImages: {
    top: newzealand3,        // Top Universities image
    campus: newzealand4,     // Campus Life image
    life: newzealand5
  },
  whyTabs: {
    top: "New Zealand hosts top universities like Auckland and Otago.",
    campus: "NZ campuses provide small class sizes, strong mentorship, and research focus.",
    life: "Life in New Zealand offers safety, scenic lifestyle, and part-time job opportunities."
  },

  universities: {
    Universities: [
     {
    name: "Massey University",
    link: "https://www.massey.ac.nz"
  },
  {
    name: "University of Canterbury",
    link: "https://www.canterbury.ac.nz"
  },
  {
    name: "AUT University",
    link: "https://www.aut.ac.nz"
  },
  {
    name: "The University of Auckland",
    link: "https://www.auckland.ac.nz"
  },
  {
    name: "University of Waikato",
    link: "https://www.waikato.ac.nz"
  }
    ],
   
  },
},

};
  const stats = [
    { number: 5000, label: "Students Placed" },
    { number: 120, label: "Partner Universities" },
    { number: 15, label: "Countries Covered" },
    { number: 98, label: "Success Rate (%)" },
  ];
export default function StudyDestinationTemplate() {
  const { country } = useParams();
  const data = destinationData[country?.toLowerCase()];
  const universities = data?.universities?.Universities ?? [];

  const [whyTab, setWhyTab] = useState("top");

 

  /* ================= TRIGGERS ================= */
  const heroRef = useRef(null);
  const descRef = useRef(null);
  const statsRef = useRef(null);
  const whyRef = useRef(null);
  const uniRef = useRef(null);

  const heroInView = useInView(heroRef, { once: true, margin: "-40px" });
const descInView = useInView(descRef, { once: true, margin: "-40px" });
const statsInView = useInView(statsRef, { once: true, margin: "-40px" });
const whyInView = useInView(whyRef, { once: true, margin: "-40px" });
const uniInView = useInView(uniRef, { once: true, margin: "-40px" });



  /* ================= COUNT UP ================= */


  const [counts, setCounts] = useState(stats.map(() => 0));

  useEffect(() => {
    if (!statsInView) return;

    stats.forEach((stat, index) => {
      let start = 0;
      const duration = 1500;
      const increment = stat.number / (duration / 20);

      const counter = setInterval(() => {
        start += increment;
        if (start >= stat.number) {
          start = stat.number;
          clearInterval(counter);
        }

        setCounts((prev) => {
          const updated = [...prev];
          updated[index] = Math.floor(start);
          return updated;
        });
      }, 20);
    });
  }, [statsInView]);
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const scaleFade = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1 },
};


  return (
     <div className="pt-0 bg-white">

{/* ================= HERO ================= */}
<div ref={heroRef} className="relative pt-15 pb-30 text-white overflow-hidden">

  <motion.div
    initial="hidden"
animate={heroInView ? "visible" : "hidden"}
variants={fadeUp}
transition={{ duration: 1 }}

    className="absolute inset-0 bg-[#2D3E9A] hero-bg-curve"
  />

 <motion.div
  initial="hidden"
  animate={heroInView ? "visible" : "hidden"}
  variants={fadeUp}
  transition={{ duration: 1, delay: 0.2 }}

    className="max-w-6xl mx-auto px-6 text-center relative z-10"
  >
    <div className="mt-10"></div>

    <p className="text-white/70 text-sm mb-3">
      Study Destinations • <span className="font-semibold">{data.name}</span>
    </p>

    <h1 className="text-4xl md:text-5xl font-extrabold mb-12 leading-tight">
      Study In {data.name}
    </h1>

    <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
      {[data.hero, data.sideImage].map((img, i) => (
        <motion.div
          key={i}
          initial="hidden"
animate={heroInView ? "visible" : "hidden"}
variants={scaleFade}

          transition={{ delay: 0.3 + i * 0.15, duration: 0.9 }}
          className="rounded-3xl overflow-hidden shadow-2xl h-[360px]"
        >
          <img src={img} alt="Study destination" className="w-full h-full object-cover" />
        </motion.div>
      ))}
    </div>
  </motion.div>
</div>

{/* ================= DESCRIPTION ================= */}
<motion.div
  ref={descRef}
  initial="hidden"
animate={descInView ? "visible" : "hidden"}
variants={fadeUp}

  transition={{ duration: 0.9 }}
  className="bg-white py-12"
>
  <div className="max-w-5xl mx-auto px-6 text-center">
    <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">
      {data.why}
    </p>
  </div>
</motion.div>

{/* ================= STATS ================= */}
<div ref={statsRef} className="bg-[#0F172A] py-20">
  <div className="max-w-7xl mx-auto px-6 text-center">

    <motion.h3
  
      initial="hidden"
animate={statsInView ? "visible" : "hidden"}
variants={fadeUp}

      transition={{ duration: 0.7 }}
      className="text-3xl md:text-4xl font-extrabold text-white mb-12"
    >
      Our Global Study Impact
    </motion.h3>

    <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-10">
      {stats.map((item, i) => (
        <motion.div
          key={i}
          initial="hidden"
animate={statsInView ? "visible" : "hidden"}
variants={fadeUp}

          transition={{ delay: i * 0.15, duration: 0.6 }}
          className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-md shadow-xl"
        >
          <h4 className="text-4xl font-extrabold text-blue-400 mb-2">
            {counts[i]}+
          </h4>
          <p className="text-white/80 text-sm tracking-wide">
            {item.label}
          </p>
        </motion.div>
      ))}
    </div>

  </div>
</div>
{/* COUNTRY DESCRIPTION SECTION */}





{/* WHY CHOOSE COUNTRY — MODERN REDESIGN */}
<motion.div
  ref={whyRef}
  
  initial="hidden"
animate={whyInView ? "visible" : "hidden"}
variants={fadeUp}

  transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
  className="bg-[#F9FAFB] py-32"
>


  <div className="max-w-7xl mx-auto px-6">

    {/* HEADER */}
   <motion.div
  initial="hidden"
animate={whyInView ? "visible" : "hidden"}
variants={fadeUp}

  transition={{ duration: 0.8 }}

      className="max-w-3xl mb-20"
    >
      <p className="text-blue-600 font-semibold tracking-wide mb-4">
        Country Insights
      </p>

      <h2 className="text-4xl md:text-6xl font-extrabold text-slate-900 leading-tight">
        Study opportunities in <br />
        <span className="text-blue-600">{data.name}</span>
      </h2>
    </motion.div>

    {/* MAIN LAYOUT */}
    <div className="grid lg:grid-cols-[280px_1fr] gap-14">

      {/* LEFT — ICON TAB NAV */}
      <div className="flex flex-col gap-4">

        {[
          { id: "top", label: "Top Universities" },
          { id: "campus", label: "Campus Life"},
          { id: "life", label: "Living Abroad" },
        ].map((tab) => (
          <motion.button
            key={tab.id}
            onClick={() => setWhyTab(tab.id)}
            whileHover={{ scale: 1.03 }}
            className={`flex items-center gap-4 px-6 py-5 rounded-2xl text-left font-semibold transition-all border ${
              whyTab === tab.id
                ? "bg-blue-600 text-white border-blue-600 shadow-lg"
                : "bg-white hover:bg-blue-50 text-slate-700 border-slate-200"
            }`}
          >
            <span className="text-2xl">{tab.icon}</span>
            {tab.label}
          </motion.button>
        ))}

        {/* FLOATING COUNTRY CARD */}
        <div className="hidden lg:block mt-10">
          <motion.div
            key={data.name}
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-3xl shadow-2xl border p-5 text-center"
          >
            <img
              src={data.flag} alt="Din"
              className="w-full h-32 object-cover rounded-xl mb-4"
            />
            <p className="font-bold text-slate-900">{data.name}</p>
          </motion.div>
        </div>

      </div>

      {/* RIGHT — CONTENT EXPERIENCE */}
      <motion.div
  key={whyTab}
  initial="hidden"
  animate={whyInView ? "visible" : "hidden"}
  variants={scaleFade}
  transition={{ duration: 0.6 }}

        className="bg-white rounded-3xl shadow-xl border overflow-hidden"
      >

        <div className="grid md:grid-cols-2 gap-12 p-12">

          {/* TEXT */}
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6">
              {whyTab === "top" && "Elite Global Universities"}
              {whyTab === "campus" && "Campus & Student Culture"}
              {whyTab === "life" && `Living in ${data.name}`}
            </h3>

            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {data.whyTabs[whyTab]}
            </p>

            {/* MINI STATS */}
            <div className="grid grid-cols-3 gap-6 mt-6">
              <div>
                <p className="text-2xl font-extrabold text-blue-600">90%+</p>
                <p className="text-sm text-slate-500">Visa Success</p>
              </div>
              <div>
                <p className="text-2xl font-extrabold text-blue-600">1200+</p>
                <p className="text-sm text-slate-500">Universities</p>
              </div>
              <div>
                <p className="text-2xl font-extrabold text-blue-600">85%</p>
                <p className="text-sm text-slate-500">Employability</p>
              </div>
            </div>
          </div>

          {/* IMAGE */}
       <AnimatePresence mode="wait">
  <motion.img
    key={whyTab}
    src={data.whyImages[whyTab]}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4 }}
    className="rounded-2xl object-cover h-[360px] w-full shadow-lg"
  />
</AnimatePresence>


        </div>

      </motion.div>

    </div>

  </div>

</motion.div>






{/* UNIVERSITIES — MEDIUM BACKGROUND CREATIVE SECTION */}
<motion.div
  ref={uniRef}
  initial="hidden"
animate={uniInView ? "visible" : "hidden"}
variants={fadeUp}

  transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
  className="relative bg-gradient-to-b from-[#CBD5E1] via-[#E2E8F0] to-[#CBD5E1] py-28 overflow-hidden"
>

  {/* SUBTLE ANIMATED GLOW */}
  <motion.div
    animate={{ opacity: [0.15, 0.35, 0.15] }}
    transition={{ repeat: Infinity, duration: 7 }}
    className="absolute inset-0 bg-gradient-to-tr from-blue-500/10 via-indigo-500/5 to-purple-500/10"
  />



  <div className="max-w-7xl mx-auto px-6 relative z-10">

    {/* HEADER */}
    <motion.div
  initial="hidden"
animate={uniInView ? "visible" : "hidden"}
variants={fadeUp}

  transition={{ duration: 0.8 }}
      className="text-center mb-16"
    >
      <p className="text-blue-700 font-semibold tracking-wide mb-3">
        Academic Excellence
      </p>

      <h3 className="text-4xl md:text-5xl font-black text-slate-900">
        Top Universities in{" "}
        <span className="text-blue-700">{data.name}</span>
      </h3>
    </motion.div>

    {/* TABS — PREMIUM MEDIUM STYLE */}
    

    {/* CREATIVE HORIZONTAL SHOWCASE */}
    <motion.div
  layout
  initial="hidden"
  animate={uniInView ? "visible" : "hidden"}
  variants={{
    hidden: {},
    visible: { transition: { staggerChildren: 0.08 } }
  }}
  className="flex lg:flex-wrap lg:justify-center gap-8 overflow-x-auto lg:overflow-visible pb-6 scrollbar-hide"

>


      {universities.map((u, i) => (

        <motion.a
          key={u.name}
          href={u.link}
          target="_blank"
           initial="hidden"
  animate={uniInView ? "visible" : "hidden"}
  variants={fadeUp}
          transition={{ delay: i * 0.07, duration: 0.6 }}
          whileHover={{ y: -12, scale: 1.04 }}
          className="min-w-[280px] lg:min-w-[300px] lg:max-w-[340px] bg-white/80  backdrop-blur-xl border border-white shadow-xl rounded-3xl p-8 hover:shadow-2xl transition group relative overflow-hidden"
        >

          {/* Glow Overlay */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition bg-gradient-to-br from-blue-500/15 to-indigo-500/15"></div>

          {/* University Name */}
          <h4 className="text-xl font-bold text-slate-900 mb-2 relative z-10">
            {u.name}
          </h4>

          {/* Link */}
          <p className="text-sm text-slate-600 mb-6 relative z-10 truncate">
            {u.link}
          </p>

          {/* CTA */}
          <div className="flex items-center justify-between mt-auto relative z-10">
            <span className="text-blue-700 font-semibold text-sm">
              Explore University
            </span>

            <motion.span
              whileHover={{ x: 6 }}
              className="text-blue-700 text-lg"
            >
              →
            </motion.span>
          </div>

        </motion.a>
      ))}

    </motion.div>

  </div>
</motion.div>


    </div>
  );
}
